import { render, staticRenderFns } from "./MembresiaEditor.vue?vue&type=template&id=c0a1f89c&scoped=true"
import script from "./MembresiaEditor.vue?vue&type=script&lang=js"
export * from "./MembresiaEditor.vue?vue&type=script&lang=js"
import style0 from "./MembresiaEditor.vue?vue&type=style&index=0&id=c0a1f89c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a1f89c",
  null
  
)

export default component.exports